import {Button, CalloutIcon} from '@wandb/components';
import React from 'react';

export type OnRetry = () => void;

interface LogViewerErrorProps {
  error: Error | string;
  onRetry?: OnRetry;
}

/**
 * LogViewerError is the default display component for errors encountered during
 * the initial fetch in 'LogViewer'. Pass in `onRetry` to render a button that
 * allows a user to try reloading the logs.
 */
export const LogViewerError: React.FC<LogViewerErrorProps> = ({
  error,
  onRetry,
}) => {
  return (
    <div
      className="flex flex-col justify-center justify-items-center h-full p-16"
      data-testid="log-viewer-initial-load-error">
      <div className="flex justify-center pb-16">
        <CalloutIcon icon="warning" color="red" size="md" />
      </div>
      <div className="flex justify-center">
        <span className="font-semibold text-2xl">Failed to load logs</span>
      </div>
      <div className="flex justify-center pb-16">
        <span className="text-lg">{getErrorMessage(error)}</span>
      </div>

      <div className="flex justify-center">
        <Button
          aria-label="Retry loading logs"
          startIcon="reload-refresh"
          onPress={onRetry}>
          Retry
        </Button>
      </div>
    </div>
  );
};

export function getErrorMessage(error: Error | string): string {
  return typeof error === 'string' ? error : error.message;
}
